import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=eb7e44a8"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"
import style0 from "./Alert.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default})
